import { BUSINESS_ALLOWED_ROLES, normalizeAuthList } from "@/constants/businessAccess"

export default defineNuxtRouteMiddleware(async to => {
  const session = useAuthSession()
  try { await session.ensure() } catch { /* Keep offline sessions available. */ }
  const token = session.read()?.token
  const roles = normalizeAuthList(session.read()?.role)
  const requiredRoles = normalizeAuthList(to.meta?.roles?.length ? to.meta.roles : BUSINESS_ALLOWED_ROLES)
  const requiredPermissions = normalizeAuthList(to.meta?.permissions)

  if (!token) {
    return navigateTo({
      path: "/user-profile",
      query: { redirect: to.fullPath, auth: "required" },
    })
  }

  if (!requiredRoles.some(role => roles.includes(role))) {
    return navigateTo("/user-profile/business-access-denied")
  }

  if (requiredPermissions.length) {
    const { can } = useBusinessAccess()
    if (!can(requiredPermissions)) return navigateTo("/user-profile/business-access-denied")
  }
})
